<template>
	<div>
		<button @click="gotoClient">Mandanten</button>
		<button @click="gotoUserClient" :class="$store.state.auth.admin !== true ? 'btnDisabled' : ''">Mandanten zu Benutzer zuweisen</button>
		<button class="btnDisabled">Eigenes Passwort ändern</button>
		<button @click="gotoUser" :class="$store.state.auth.admin !== true ? 'btnDisabled' : ''">Benutzer</button>
	</div>
</template>

<script>
  export default {
    components: {},
	data() {
		return {}
	},
    methods: {
      gotoClient: function () {
        this.$router.push({ path: '/home/configuration/client'})
      },
      gotoUser: function () {
		if (this.$store.state.auth.admin !== true) return
        this.$router.push({ path: '/home/configuration/user'})
      },
      gotoUserClient: function () {
		if (this.$store.state.auth.admin !== true) return
        this.$router.push({ path: '/home/configuration/user_client'})
      }
    }
  }
</script>

<style scoped="">
button {
	display: block;
	cursor: pointer;
	width: 500px;
	font-size: 25px;
	font-weight: 700;
	line-height: 50px;
	margin: 50px auto;
	background: #888;
	border: 1px solid #000;
	color: #fff;
}

button:hover {
	background: #666;
}

.btnDisabled {
	background: #ccc;
	cursor: auto;
	color:#888;
	border-color: #888;
}

.btnDisabled:hover {
	background: #ccc;
}
</style>
